import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ViewMode } from '../../../../models';
import { DatePickerExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

@Component({
  selector: 'date-picker-example',
  templateUrl: './date-picker-example.component.html',
  styleUrls: ['./date-picker-example.component.scss'],
  standalone: false,
})
export class DatePickerExampleComponent implements OnChanges {
  @Input() template;
  @Input() mode: ViewMode = null;
  title: string = 'Schedule delivery in Toronto';
  description: string = "You'll choose a date and time at checkout";
  type: string = DatePickerExtension.DeliveryDatePickerType.CALENDAR;
  label: string = 'Label';
  placementMode = 'standalone';
  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    this.setFixedComponentData(this.template);
  }

  setFixedComponentData(template) {
    if (template?.type) {
      this.type = template?.type;
    }
    if (Boolean(template?.title) || template.title == '') {
      this.title = template?.title;
    }
    if (Boolean(template?.description) || template.description == '') {
      this.description = template?.description;
    }
    if (Boolean(template?.label) || template.label == '') {
      this.label = template?.label;
    }
    this.placementMode = template.placementMode;
  }
}
